/**
 * 文件说明:
 * ----------------------------------------
 * 创建用户: leo
 * 创建日期 2019/11/22
 */
import produce, {enableAllPlugins} from 'immer'
import {hzDvaConfigMerge} from 'umi'

enableAllPlugins()

const NAMESPACE_SEP = '/'
const IMMER_ACTION_PREFIX = 'immer'

function getImmerAction(type) {
    const actionName = type.split(NAMESPACE_SEP)[1]
    return actionName.indexOf(IMMER_ACTION_PREFIX) === 0
}

export function dva(config) {
    return hzDvaConfigMerge(config, {
     plugins: [
            {
                onEffect: (effect) =>
                    function effectAction(...args) {
                        if (args[0]) {
                            args[0].produce = produce
                        }

                        return effect(...args)
                    },
                _handleActions(handlers, defaultState) {
                    return (state = defaultState, action) => {
                        const {type} = action
                        const handler = handlers[type]

                        if (handler) {
                            if (getImmerAction(type)) {
                                return produce(state, (draft) => handler(draft, action))
                            }

                            return handler(state, action)
                        }

                        return state
                    }
                },
            },
        ],
    })
}
